import { IEnvVars } from "shared/utils";

const PROD_ENV_VARS: IEnvVars = {
  CLIENT_ID: "67154-ASDS-WebApp",
  API_ENDPOINT: "https://apm-settings-tool-exp.aerospace1.honeywellaerospace.com/apm",
  FEL_ENDPOINT: "https://asds.honeywellaerospace.com/servicerequest/elt/swlib/servicehome.do",
  ASDS_ENDPOINT: "https://ads.honeywellaerospace.com/ads/broadcast/message",
};

export default PROD_ENV_VARS;
